import axios from 'axios';

export default ({}, inject) => {
  inject(
    'animaapi',
    axios.create({
      baseURL: 'https://api.animaapp.com',
    })
  );
};
